const state = {
    itens: [],
    item: {
        description: ''
    }
};

export default state;